import Return from "./commands/return";

class Emitter {
    constructor(commandFactory) {
        this.commandFactory = commandFactory;
        this.returnValue = null;
    }

    async emit(ast, options) {
        this.returnValue = null;
        for (const node of ast.params) {
            await this.processNode(node, options);
        }

        return this.returnValue;
    }

    async processNode(node, options) {
        if (node.name === "" && node.type === "expression") {
            return await this.emit(node, options);
        }

        const command = this.commandFactory.getCommand(node.name);
        if (command instanceof Return) {
            this.returnValue = await command.execute(node, this.processNode.bind(this), options);
        } else if (command) {
            return await command.execute(node, this.processNode.bind(this), options);
        } else {
            return node.getInterpolatedValue();
        }
    }
}

export default Emitter;
